import { HD_MOTOR_CENTERS } from './basic-properties/hd-chart-properties.constants';
import { HdBodygraphChannelDefinition } from './hd-bodygraph.models';

/**
 * Kanaaltype volgens Ra's "Channels by Type": een kanaal manifesteert
 * (motor → keel), genereert (sacraal doet mee) of wordt geprojecteerd (al de
 * rest). De indeling is zuiver topologisch en wordt hier afgeleid uit de
 * center-paren van {@link HdBodygraphChannelDefinition} in plaats van per
 * kanaal hardcoded — zo kán hij nooit uit de pas lopen met de metadata.
 *
 * Nuances uit de boekenreeks:
 * - 34-20 (Charisma) is topologisch generated (sacraal → keel) en tegelijk hét
 *   Manifesting-Generator-kanaal; de badge {@link isHdManifestingGeneratorChannel}
 *   draagt die nuance in de weergave.
 * - Volume 1 licht een aantal kanalen uit als "creatieve" kanalen
 *   ({@link HD_CREATIVE_CHANNEL_KEYS}); dat is een extra laag bovenop het type,
 *   geen vierde type.
 */
export type HdChannelTypeKey = 'manifested' | 'generated' | 'projected';

/** Weergavevolgorde van de groepen (volgt de volumes van Channels by Type). */
export const HD_CHANNEL_TYPE_ORDER: readonly HdChannelTypeKey[] = ['manifested', 'generated', 'projected'];

/** Kanalen die Channels by Type vol. 1 als creatieve kanalen uitlicht. */
export const HD_CREATIVE_CHANNEL_KEYS: ReadonlySet<string> = new Set(['8-1', '16-48', '25-51', '35-36']);

/** Hét Manifesting-Generator-kanaal (Charisma). */
export function isHdManifestingGeneratorChannel(channelKey: string): boolean {
  return channelKey === '34-20';
}

export function hdChannelTypeFor(channel: HdBodygraphChannelDefinition): HdChannelTypeKey {
  if (channel.centers.includes('sacraal')) {
    return 'generated';
  }
  const connectsThroat = channel.centers.includes('keel');
  const connectsMotor = channel.centers.some(center => HD_MOTOR_CENTERS.includes(center));
  return connectsThroat && connectsMotor ? 'manifested' : 'projected';
}
